import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, l ] = [ window, document, location ]

const init = () => {
  $.when( w.load['header'] ).then( () => {
    $('.p-gnav__list').currentMenu({mode: 0, url: l.pathname+l.search });
  });

  //設備案内 slot
  $.when( w.load['corporate01-content'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="facility-section"]' )
    slot ? $obj.replaceWith( slot ) : $obj.hide()
  });

  //会社概要 slot
  $.when( w.load['corporate02-content'] ).then( ( html, slot ) => {
    let $obj = $( '[data-slot="corporate-outline"]' )
    slot ? $obj.replaceWith( slot ) : $obj.hide()
  });

  //募集職種 一覧
  $.when(w.load['corporate03']).then(() => {
    let makeItem = item => $(`
      <li class="recruit-require-item">
        <a href="${item.href}" class="recruit-require-item__link">
          <figure class="recruit-require-item__img">
            <div class="recruit-require-item__img-cover" style="background-image:url(${item.thumb})"><img src="${item.thumb}" alt="${item.title}" width="200" loading="lazy"></div>
          </figure>
          <div class="recruit-require-item__body">
            <h3 class="subject">${item.title.str_truncate(24)}</h3>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.recruit-require__list[data-plugin="getArticles"]', { makeItem }).then( items => {
      if( items.length == 0 ) {
        $('.recruit-require__list[data-plugin="getArticles"]').append('<p class="recruit-require__text text-center">現在、募集は行っておりません。</p>');
        $('.recruit-require__btnwrap', '.recruit-require').hide();
      }
    });
  })
}

export default function CORPORATE () {
  $( init )
}